
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexCROfAaC1CFM_v3wxntO6e_45t_zRMch2VHIXtJ2fm9ePEMeta } from "/appli/pages/index.vue?macro=true";
import { default as qrGX13XTv5o0oq5ckA0yn8VyaR_6hSuGRvS7wd2KWqIc0Meta } from "/appli/pages/user/qr.vue?macro=true";
import { default as indexF9JAhWUEmqJPaEZig3rnVt81aWOmkxawTTDmJSuwofgMeta } from "/appli/pages/login/index.vue?macro=true";
import { default as maintenanceW354r7BeHPPAqR4ljr3OaOzUp8KBD7N4Ag9orw9dF30Meta } from "/appli/pages/maintenance.vue?macro=true";
import { default as confirm3nomSwYsv4t4VMu7A5XxxRhtZfLN7OIwSPl4eKer6_QMeta } from "/appli/pages/register/confirm.vue?macro=true";
import { default as payuby4XdEFxgQJjQCuxzd6R9UXyeNHO5NxKu5tvhpfJRcMeta } from "/appli/pages/user/payment/pay.vue?macro=true";
import { default as completeWhp5HIK4mMgyBGovVm_Eeyxy_45NJDwTUFe4TLtctP4zoMeta } from "/appli/pages/register/complete.vue?macro=true";
import { default as gatesRlb6ZlcaDNa2n_45j2qykLiC5PqOVi9Vqt6yiP71fD_45DYMeta } from "/appli/pages/user/mypage/gates.vue?macro=true";
import { default as indexh9V3ZGg78aBwpO2M4Ox7Wsc2wQoaDK6Ici4MiMPlv6UMeta } from "/appli/pages/user/mypage/index.vue?macro=true";
import { default as pastgJ7Sj2MJS_45gmGzbzdTuWcmPtzuMBg8jnpZSFDWX0ePkMeta } from "/appli/pages/user/payment/past.vue?macro=true";
import { default as myinfoXDge6eW_9MMtc1559DGHLBXgXnIWN0_45f0C8_1f66jMoMeta } from "/appli/pages/user/mypage/myinfo.vue?macro=true";
import { default as indexDFUuX6U7YqE3WAXTCsvjWJTmXHFutxYvNkI5oy7juOoMeta } from "/appli/pages/user/payment/index.vue?macro=true";
import { default as update_45logO_45qKpKVm_VvH_LVWl__45QW0kg2XBFcg29TC_1No6HpfoMeta } from "/appli/pages/corporate/update-log.vue?macro=true";
import { default as pastDYPvJYcfdOmL008KtqRGB3P6l2AwhEPNA4SF7G_453_452oMeta } from "/appli/pages/user/reservation/past.vue?macro=true";
import { default as _91tenant_code_934_45K0As_4529Xs4XPLxqjSP03DUu2CPkZMD8UAE175CB6sMeta } from "/appli/pages/register/[tenant_code].vue?macro=true";
import { default as email_resetuOZ9w01m0eG_ybbgVt3_45Fc9wQg_450Sgh0AE93Ow08OG0Meta } from "/appli/pages/user/email/email_reset.vue?macro=true";
import { default as indexYXE1obAimnQGcM19e8W_KqHZwSUe9vvzS22zZRy_45J6oMeta } from "/appli/pages/user/reservation/index.vue?macro=true";
import { default as password_resetLQdn_5J5Ffal9S4PthkRVsspnGqsZMwsT_45fxJz1zrY8Meta } from "/appli/pages/password/password_reset.vue?macro=true";
import { default as canceld5nWscYt_45hH4yylZL2bGNZQ2z9l2iWpUBsmVAzCFJiIMeta } from "/appli/pages/user/reservation/cancel.vue?macro=true";
import { default as send_reset_email4jeGHKqWq7Fm2PFbDnkqvZYOQbv3c_7M4kkxWdCFcp0Meta } from "/appli/pages/password/send_reset_email.vue?macro=true";
import { default as indexbADPYAsn9tTYpA_aOfxATMdgYBumCS4_455WTzMw8BAu4Meta } from "/appli/pages/booking/[tenant_code]/index.vue?macro=true";
import { default as send_reset_emaillC3OB8OK8a4G7b9NRhFD5_45eJur7QBqeCYqkKMNbNDxYMeta } from "/appli/pages/user/email/send_reset_email.vue?macro=true";
import { default as payggzKp6U3nBiaXmXw_45qnoXE_4wtrZoY4_45kFIW3YRg6A1wMeta } from "/appli/pages/user/mypage/tenant/[tenant_code]/payg.vue?macro=true";
import { default as index4vvM9Bj1F5hvRuT6urfo_45_45_OYNM9yB_5XJ22NraiAQwMeta } from "/appli/pages/user/mypage/tenant/[tenant_code]/index.vue?macro=true";
import { default as myinfoo3jLyqQkEMYCgvaxoezgfvMPogwLajwQjyfdR4jfAU4Meta } from "/appli/pages/user/mypage/tenant/[tenant_code]/myinfo.vue?macro=true";
import { default as myplantZB2FjxLTzriBlxGkMSE5SH0GzdIad4YKpGPHXJ4W0QMeta } from "/appli/pages/user/mypage/tenant/[tenant_code]/myplan.vue?macro=true";
import { default as booking_454VVTl7_xBXdb7wsyvazgSnk427Xmi1HMRqjpxwia8UMeta } from "/appli/pages/user/mypage/tenant/[tenant_code]/booking.vue?macro=true";
import { default as booking_doneZc1VfF26Q9ayTZY6BDN4Kx6765iKpXF_vtvmb6o1TdMMeta } from "/appli/pages/user/mypage/tenant/[tenant_code]/booking_done.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexCROfAaC1CFM_v3wxntO6e_45t_zRMch2VHIXtJ2fm9ePEMeta || {},
    component: () => import("/appli/pages/index.vue")
  },
  {
    name: "user-qr",
    path: "/user/qr",
    component: () => import("/appli/pages/user/qr.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexF9JAhWUEmqJPaEZig3rnVt81aWOmkxawTTDmJSuwofgMeta || {},
    component: () => import("/appli/pages/login/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/appli/pages/maintenance.vue")
  },
  {
    name: "register-confirm",
    path: "/register/confirm",
    meta: confirm3nomSwYsv4t4VMu7A5XxxRhtZfLN7OIwSPl4eKer6_QMeta || {},
    component: () => import("/appli/pages/register/confirm.vue")
  },
  {
    name: "user-payment-pay",
    path: "/user/payment/pay",
    component: () => import("/appli/pages/user/payment/pay.vue")
  },
  {
    name: "register-complete",
    path: "/register/complete",
    meta: completeWhp5HIK4mMgyBGovVm_Eeyxy_45NJDwTUFe4TLtctP4zoMeta || {},
    component: () => import("/appli/pages/register/complete.vue")
  },
  {
    name: "user-mypage-gates",
    path: "/user/mypage/gates",
    component: () => import("/appli/pages/user/mypage/gates.vue")
  },
  {
    name: "user-mypage",
    path: "/user/mypage",
    component: () => import("/appli/pages/user/mypage/index.vue")
  },
  {
    name: "user-payment-past",
    path: "/user/payment/past",
    component: () => import("/appli/pages/user/payment/past.vue")
  },
  {
    name: "user-mypage-myinfo",
    path: "/user/mypage/myinfo",
    component: () => import("/appli/pages/user/mypage/myinfo.vue")
  },
  {
    name: "user-payment",
    path: "/user/payment",
    component: () => import("/appli/pages/user/payment/index.vue")
  },
  {
    name: "corporate-update-log",
    path: "/corporate/update-log",
    component: () => import("/appli/pages/corporate/update-log.vue")
  },
  {
    name: "user-reservation-past",
    path: "/user/reservation/past",
    component: () => import("/appli/pages/user/reservation/past.vue")
  },
  {
    name: "register-tenant_code",
    path: "/register/:tenant_code()",
    meta: _91tenant_code_934_45K0As_4529Xs4XPLxqjSP03DUu2CPkZMD8UAE175CB6sMeta || {},
    component: () => import("/appli/pages/register/[tenant_code].vue")
  },
  {
    name: "user-email-email_reset",
    path: "/user/email/email_reset",
    meta: email_resetuOZ9w01m0eG_ybbgVt3_45Fc9wQg_450Sgh0AE93Ow08OG0Meta || {},
    component: () => import("/appli/pages/user/email/email_reset.vue")
  },
  {
    name: "user-reservation",
    path: "/user/reservation",
    component: () => import("/appli/pages/user/reservation/index.vue")
  },
  {
    name: "password-password_reset",
    path: "/password/password_reset",
    meta: password_resetLQdn_5J5Ffal9S4PthkRVsspnGqsZMwsT_45fxJz1zrY8Meta || {},
    component: () => import("/appli/pages/password/password_reset.vue")
  },
  {
    name: "user-reservation-cancel",
    path: "/user/reservation/cancel",
    component: () => import("/appli/pages/user/reservation/cancel.vue")
  },
  {
    name: "password-send_reset_email",
    path: "/password/send_reset_email",
    meta: send_reset_email4jeGHKqWq7Fm2PFbDnkqvZYOQbv3c_7M4kkxWdCFcp0Meta || {},
    component: () => import("/appli/pages/password/send_reset_email.vue")
  },
  {
    name: "booking-tenant_code",
    path: "/booking/:tenant_code()",
    meta: indexbADPYAsn9tTYpA_aOfxATMdgYBumCS4_455WTzMw8BAu4Meta || {},
    component: () => import("/appli/pages/booking/[tenant_code]/index.vue")
  },
  {
    name: "user-email-send_reset_email",
    path: "/user/email/send_reset_email",
    component: () => import("/appli/pages/user/email/send_reset_email.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code-payg",
    path: "/user/mypage/tenant/:tenant_code()/payg",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/payg.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code",
    path: "/user/mypage/tenant/:tenant_code()",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/index.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code-myinfo",
    path: "/user/mypage/tenant/:tenant_code()/myinfo",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/myinfo.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code-myplan",
    path: "/user/mypage/tenant/:tenant_code()/myplan",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/myplan.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code-booking",
    path: "/user/mypage/tenant/:tenant_code()/booking",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/booking.vue")
  },
  {
    name: "user-mypage-tenant-tenant_code-booking_done",
    path: "/user/mypage/tenant/:tenant_code()/booking_done",
    component: () => import("/appli/pages/user/mypage/tenant/[tenant_code]/booking_done.vue")
  }
]